var map = {
	"./cat": "MGUO",
	"./cat.js": "MGUO",
	"./cd": "OkV7",
	"./cd.js": "OkV7",
	"./chmod": "thPH",
	"./chmod.js": "thPH",
	"./common": "8y2q",
	"./common.js": "8y2q",
	"./cp": "kEp2",
	"./cp.js": "kEp2",
	"./dirs": "lK6y",
	"./dirs.js": "lK6y",
	"./echo": "IRJ8",
	"./echo.js": "IRJ8",
	"./error": "HxTw",
	"./error.js": "HxTw",
	"./exec": "VQ1x",
	"./exec.js": "VQ1x",
	"./find": "r+ID",
	"./find.js": "r+ID",
	"./grep": "T3mR",
	"./grep.js": "T3mR",
	"./head": "jMmx",
	"./head.js": "jMmx",
	"./ln": "4Bxg",
	"./ln.js": "4Bxg",
	"./ls": "MULN",
	"./ls.js": "MULN",
	"./mkdir": "3ORl",
	"./mkdir.js": "3ORl",
	"./mv": "PcVt",
	"./mv.js": "PcVt",
	"./popd": "h3Dv",
	"./popd.js": "h3Dv",
	"./pushd": "PGBa",
	"./pushd.js": "PGBa",
	"./pwd": "+UCj",
	"./pwd.js": "+UCj",
	"./rm": "EaF0",
	"./rm.js": "EaF0",
	"./sed": "/j+X",
	"./sed.js": "/j+X",
	"./set": "c0cj",
	"./set.js": "c0cj",
	"./sort": "yc2b",
	"./sort.js": "yc2b",
	"./tail": "i//j",
	"./tail.js": "i//j",
	"./tempdir": "RvNk",
	"./tempdir.js": "RvNk",
	"./test": "U9dR",
	"./test.js": "U9dR",
	"./to": "xlaY",
	"./to.js": "xlaY",
	"./toEnd": "Lk2e",
	"./toEnd.js": "Lk2e",
	"./touch": "0Qa2",
	"./touch.js": "0Qa2",
	"./uniq": "lTxy",
	"./uniq.js": "lTxy",
	"./which": "GiAy",
	"./which.js": "GiAy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "FsJg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/shelljs/src ^\.\/.*$
// module id = FsJg
// module chunks = 1